






































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch} from "@vue/composition-api";

// components
import BaseAvatar from '@/components/NEW-STRUCTURE/desktop/Admin/components/BaseAvatar.vue';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

// types
import { ChannelMember } from '@/views/Admin/Channels/channelTypes';


export default defineComponent({
    components: {
        SubTitle,
        BaseAvatar,
    },
    props: {
        channelMember: ChannelMember,
    },
    setup(props, context) {

        const handleGoBack = () => {
            context.emit('goBack');
        }

        const handleViewUnit = () => {
            // @ts-ignore
            context.root.$router.push({ path: `/admin/units/${props.channelMember.unitId}` });
        }

        const handleMessage = () => {
            // TODO redirect to the user's unit page
            console.log("handle message");
        }

        return {
            handleGoBack,
            handleMessage,
            handleViewUnit,
        };
    }
});
